import React from 'react';

interface DataCenterCardProps {
  title: string;
  icon: React.ReactNode;
  onClick?: () => void;
  isEnabled?: boolean;
  description?: string;
  disabledMessage?: string;
}

const DataCenterCard: React.FC<DataCenterCardProps> = ({
  title,
  icon,
  onClick,
  description,
  isEnabled = true,
  disabledMessage = 'This data center is currently unavailable.',
}) => {
  const handleClick = () => {
    if (!isEnabled) return;
    onClick?.();
  };

  console.log(`DataCenterCard - Title: ${title}, isEnabled: ${isEnabled}`);
  return (
    <div
      title={!isEnabled ? disabledMessage : undefined}
      onClick={handleClick}
      style={{
        backgroundColor: isEnabled ? '#FFFFFF' : '#E5E7EB',
        padding: '2rem',
        borderRadius: '12px',
        border: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        cursor: isEnabled && onClick ? 'pointer' : 'not-allowed',
        opacity: 1,
        transition: 'all 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '160px',
        gap: '1rem',
        pointerEvents:'auto',
      }}
      onMouseEnter={(e) => {
        if (!isEnabled || !onClick) return;
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.15)';
      }}
      onMouseLeave={(e) => {
        if (!isEnabled || !onClick) return;
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
      }}
    >
      <div style={{ fontSize: '3rem', color: isEnabled ? '#61A1D4' : '#9CA3AF' }}>
        {icon}
      </div>

      <h3
        style={{
          fontSize: '1.25rem',
          fontWeight: '600',
          color: '#111827',
          margin: 0,
          textAlign: 'center',
        }}
      >
        {title}
      </h3>

      {description && (
        <p
          style={{
            fontSize: '0.875rem',
            color: '#6B7280',
            margin: 0,
            textAlign: 'center',
          }}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default DataCenterCard;
